import axiosInstance from '../config/axios';

export const getPrograms = async () => {
  return axiosInstance.get('/programs');
};

export const getSubPrograms = async () => {
  return axiosInstance.get('/sub-programs');
};

export const getCourseDetails = async (id) => {
  return axiosInstance.get(`/programs/${id}`);
};

export const getTimeSlots = async (levelId) => {
  return axiosInstance.get(`/skill-levels/${levelId}/time-slots`);
};

export const addToCart = async (payload) => {
  return axiosInstance.post('/cart', payload);
};

export const getUserPrograms = async () => {
  return axiosInstance.get('/user/bookings');
};

export const getPaymentHistory = async (userId) => {
  return axiosInstance.get(`/payment-history/${userId}`);
}

export const getSkillsbyFocus = async (focusId) => {
  return axiosInstance.get(`skill-data/by-focus/${focusId}`);
}